import { Link } from 'react-router-dom';
import Spinner from '../../features/loading/Spinner';

export function LoadingIndicator({ expanded }: { expanded: boolean }) {
  if (expanded) return null;
  return (
    <>
      <h4 className="align-self-center ml-2">
        <Link to="/reflex/configs" className="text-decoration-none" onClick={(e) => e.stopPropagation()}>
          Reflex
        </Link>
      </h4>
      <div className="d-flex align-items-center">
        <Spinner />
      </div>
    </>
  );
}

export default LoadingIndicator;
